import { Group, Text } from "@mantine/core";
import MoreActions from "./MoreActions";
import classes from "./FieldFunctionWrapper.module.scss";

/**
 * Recursive wrapper that shows a "Function: {name}" header above a field,
 * recursing through childEntityFieldFunction for compound functions
 * (e.g. SUM(AVG(field))). content is the inner field UI rendered at the leaf.
 */
export default function FieldFunctionWrapper({
  ruleId,
  fieldsData,
  functionData,
  content,
  id,
  setNameEditMode,
  canEdit = true,
  isRightField = false,
}) {
  return (
    <div className={classes.wrapper}>
      <Group justify="flex-end" gap="xs" wrap="nowrap">
        <Text size="sm" c="dimmed">
          Function {functionData?.function?.name}
        </Text>
        {canEdit && (
          <MoreActions
            ruleId={ruleId}
            fieldsData={fieldsData}
            parentFunctionId={functionData.id}
            id={id}
            setNameEditMode={setNameEditMode}
            isRightField={isRightField}
          />
        )}
      </Group>
      {functionData.childEntityFieldFunction ? (
        <FieldFunctionWrapper
          ruleId={ruleId}
          fieldsData={fieldsData}
          functionData={functionData.childEntityFieldFunction}
          content={content}
          id={id}
          setNameEditMode={setNameEditMode}
          canEdit={canEdit}
          isRightField={isRightField}
        />
      ) : (
        content
      )}
    </div>
  );
}
